module.exports = __webpack_public_path__ + "img/cooperation13.695382ce.png";